import {environment} from '~env/environment';

export const TOGGLE_URLS = () => `${environment.appStaticUrl()}/api/v1/feature-toggles`;
